import { AlertTriangle, ReceiptText, ShoppingCart, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import CustomerNav from "./CustomerNav";

// Fallback KHUSUS Checkout. Sengaja TIDAK menyediakan "Muat ulang / Coba lagi":
// bila UI crash setelah tombol "Buat pesanan" ditekan, pesanan bisa jadi sudah
// tercatat di server. Reload/resubmit berisiko membuat pesanan ganda. Karena itu
// kita hanya menawarkan navigasi aman: cek Riwayat Pesanan atau kembali ke Keranjang.
export default function CheckoutErrorFallback() {
  const nav = useNavigate();
  const { settings } = useSettings();
  const wa = settings?.nomor_whatsapp || "";
  const waLink = wa ? `https://wa.me/${wa.replace(/[^0-9]/g, "")}` : null;

  const clearIdemKeys = () => {
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith("hoon_checkout_idem_"))
        .forEach((k) => localStorage.removeItem(k));
    } catch { /* abaikan */ }
  };

  return (
    <div className="hsv5 min-h-screen">
      <CustomerNav />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="checkout-error-fallback" role="alert">
        <div className="rounded-2xl border border-[#FFCBAF] bg-[#FFF1E8] p-6 sm:p-8">
          <div className="flex items-start gap-4">
            <AlertTriangle size={26} className="text-[#1D1D1F] mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <h1 className="font-heading text-xl sm:text-2xl font-extrabold text-[#1D1D1F]">
                Halaman checkout gagal dimuat.
              </h1>
              <p className="text-sm text-[#1D1D1F] mt-2 leading-relaxed">
                Terjadi kesalahan pada halaman ini. <b>Jangan menekan tombol buat pesanan berulang kali.</b>{" "}
                Jika Anda tadi sudah menekan "Buat pesanan", pesanan Anda mungkin
                <b> sudah tercatat</b>. Untuk memastikan tanpa membuat pesanan ganda,
                periksa Riwayat Pesanan Anda.
              </p>

              <div className="mt-5 flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => nav("/pesanan")}
                  data-testid="checkout-error-view-orders"
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#FF6B1A] text-white px-4 py-2.5 text-sm font-semibold hover:opacity-90 transition-colors"
                >
                  <ReceiptText size={17} /> Lihat Riwayat Pesanan
                </button>
                <button
                  onClick={() => { clearIdemKeys(); nav("/keranjang"); }}
                  data-testid="checkout-error-back-to-cart"
                  className="inline-flex items-center justify-center gap-2 rounded-xl border border-[#FF6B1A] bg-white text-[#1D1D1F] px-4 py-2.5 text-sm font-semibold hover:bg-[#FFF1E8] transition-colors"
                >
                  <ShoppingCart size={17} /> Kembali ke Keranjang
                </button>
              </div>

              {waLink && (
                <a
                  href={waLink}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="checkout-error-whatsapp"
                  className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:text-emerald-800"
                >
                  <PhoneCall size={16} /> Butuh bantuan? Hubungi kami melalui WhatsApp {wa}
                </a>
              )}

              {/* Teks pembeli 28/10/2026: detail teknis tidak tampil ke pembeli (sudah dicatat ErrorBoundary di console) */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
